<template lang="pug">
v-layout.mb-4.mt-4.wider(wrap)
  v-card.pa-4.mr-4.picker-card
    v-layout(column, justify-space-between, align-center, full-height)
      h3 Logo plaatsen
      picture-input(
        @change='logoChange',
        :hideChangeButton='true',
        :customStrings='pictureInputStrings',
        ref='logoInput',
        :z-index='0',
        :prefill='logo === "remove" ? null : logo'
        )
      v-btn(flat, @click='removeLogo') Logo verwijderen

  v-card.pa-4.mr-4.picker-card
    v-layout(column, align-center)
      h3.mb-2 Huisstijl kleur
      chrome-picker.elevation-0(
        v-model='primaryColorModel',
        :disableAlpha='true'
        )

  v-card.pa-4.mr-4.picker-card
    v-layout(column, align-center)
      h3.mb-2 Achtergrond kleur
      chrome-picker.elevation-0(
        v-model='backgroundColorModel',
        :disableAlpha='true'
        )

  v-card.pa-4.mr-4.picker-card
    v-layout(column, justify-space-between, align-center, full-height)
      h3 Achtergrond plaatsen
      picture-input(
        @change='backgroundImageChange',
        :hideChangeButton='true',
        :customStrings='pictureInputStrings',
        ref='backgroundImageInput',
        :z-index='0',
        :prefill='backgroundImage === "remove" ? null : backgroundImage'
        )
      v-btn(flat, @click='removeBackgroundImage') Achtergrond verwijderen
</template>

<script>
import { Chrome } from 'vue-color'
import PictureInput from 'vue-picture-input'

export default {
  props: {
    primaryColor: String,
    backgroundColor: String,
    logo: null,
    backgroundImage: null,
    disabled: Boolean
  },

  components: {
    ChromePicker: Chrome,
    PictureInput
  },

  data () {
    return {
      primaryColorModel: this.primaryColor,
      backgroundColorModel: this.backgroundColor,

      pictureInputStrings: {
        drag: 'Klik of sleep hier een afbeelding'
      }
    }
  },

  methods: {
    logoChange () {
      this.$emit('update:logo', this.$refs.logoInput.file)
      this.$emit('update:logoPreview', this.$refs.logoInput.image)
    },

    removeLogo () {
      this.$refs.logoInput.removeImage()

      this.$emit('update:logo', 'remove')
      this.$emit('update:logoPreview', null)
    },

    backgroundImageChange () {
      this.$emit('update:backgroundImage', this.$refs.backgroundImageInput.file)
      this.$emit('update:backgroundImagePreview', this.$refs.backgroundImageInput.image)
    },

    removeBackgroundImage () {
      this.$refs.backgroundImageInput.removeImage()

      this.$emit('update:backgroundImage', 'remove')
      this.$emit('update:backgroundImagePreview', null)
    }
  },

  mounted () {
    setTimeout(() => {
      this.$emit('update:logoPreview', this.$refs.logoInput.image)
      this.$emit('update:backgroundImagePreview', this.$refs.backgroundImageInput.image)
    }, 100);
  },

  watch: {
    primaryColorModel (v) {
      this.$emit('update:primaryColor', v.hex)
    },

    backgroundColorModel (v) {
      this.$emit('update:backgroundColor', v.hex)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/responsive.scss";

.picker-card {
  $width: 240px;

  width: $width;
  min-width: $width;

  margin-bottom: $g;

  h3 {
    white-space: nowrap;
  }
}
</style>

<style lang="scss">
.picture-input {
  .picture-preview {
    height: 181px !important;
    margin-top: 8px;
  }
}
</style>
